import "core-js/modules/es6.function.name";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import debounce from 'lodash/debounce';
import { mapGetters, mapActions } from 'vuex';
import { MERCURE_OPENING_STATUS } from '~/const/orders';
import { FAST_TIMER } from '~/const/timers';
import ProductCard from '~/components/molecules/Global/ProductCard.vue';

var MdmModal = function MdmModal() {
  return import(
  /* webpackChunkName: "modal" */
  '~/components/atoms/Global/MdmModal.vue');
};

export default {
  name: 'AddToCartModal',
  components: {
    MdmModal: MdmModal,
    ProductCard: ProductCard
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      quantity: 1,
      show: false,
      btnDisabled: false
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    cartItems: 'customer/cartItems',
    items: 'cart/items',
    success: 'cart/success'
  }), {
    productName: function productName() {
      return this.product.line ? "".concat(this.product.line, " - ").concat(this.product.name) : this.product.name;
    },
    openingStatus: function openingStatus() {
      return this.$cookies.get('MDM_TEST_MERCURE') || MERCURE_OPENING_STATUS[this.locale.iso];
    },
    cartUrl: function cartUrl() {
      return this.buildCartUrl(this.locale, this.openingStatus);
    },
    quantityTracking: function quantityTracking() {
      return {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_quantite',
          event_label: "".concat(window.tc_vars.page_cat1, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      };
    },
    showError: function showError() {
      if (this.openingStatus) {
        return !this.success;
      }

      return false;
    }
  }),
  watch: {
    showModal: function showModal() {
      if (this.showModal) {
        if (this.openingStatus) {
          var item = this.items[this.product.reference] || {};
          this.quantity = item.quantity || 1;
        } else {
          this.quantity = this.cartItems[this.product.reference] || 1;
        }
      }
    }
  },
  methods: _objectSpread({}, mapActions({
    updateCart: 'customer/updateCart',
    updateCartMercure: 'cart/updateCart'
  }), {
    debounceUpdateQty: debounce(function updateCartQuantity(event) {
      var _this = this;

      var updateCartAction = this.updateCart;

      if (this.openingStatus) {
        updateCartAction = this.updateCartMercure;
      }

      updateCartAction({
        reference: this.product.reference,
        quantity: this.quantity
      }).then(function () {
        _this.btnDisabled = false;
      });
      this.trackQuantityChange(event);
    }, FAST_TIMER),
    decrementQuantity: function decrementQuantity() {
      if (parseInt(this.quantity, 10) <= 1) {
        return;
      }

      this.quantity = parseInt(this.quantity, 10) - 1;
    },
    incrementQuantity: function incrementQuantity() {
      if (parseInt(this.quantity, 10) >= 30) {
        return;
      }

      this.quantity = parseInt(this.quantity, 10) + 1;
    },
    trackQuantityChange: function trackQuantityChange(event) {
      this.$root.$emit('generic-tracking', event, this.quantityTracking);
    }
  })
};